import {loadJSON} from "./loadJSON";
import {promptUserLogin} from "../actions/userAccess";
import {ERRORS} from './constants'

export const ACTION_UPDATE_SUFFIX = ':update';

function noOp() {}
export function createActionMiddleware(myAction, prepareCall, successCallback = noOp) {

    let latestRequest;
    const myActionUpdate = myAction + ACTION_UPDATE_SUFFIX;
    const genericMiddleware = store => next => action => {

        switch(action.type) {
            case myAction: {
                latestRequest = action;
                store.dispatch({
                    actionId: action.actionId,
                    type: myActionUpdate
                });

                const config = prepareCall(action, store);
                // Get the server from the state
                const server = store.getState().userAccess.server
                return loadJSON(config, server).then(res => {
                    
                    if(latestRequest === action) {

                        store.dispatch({
                            actionId: action.actionId,
                            type: myActionUpdate,
                            result: res
                        });
                        successCallback(store, action, res);
                    }
                }, err => {
                    console.log('err ', err)
                    if(latestRequest === action) {
                        const handler = setupErrorHandler(store, myActionUpdate, action.actionId);
                        handler(err);
                    }
                });
            }
            default:
                return next(action);
        }
    };

    return genericMiddleware;
}

function setupErrorHandler(store, actionName, actionId, originalAction) {
    return error => {
        store.dispatch({
            actionId,
            originalAction,
            type: actionName,
            error
        });

        // should only ask users to login when they need to be granted access
        if (error.name === ERRORS.LOGIN) {
            store.dispatch(promptUserLogin())
        }
    }
}